module.exports = __webpack_public_path__ + "img/2.fbd8902c.png";